

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { Box, Button, Grid, KeyValue, Link, SectionHeader, Typography } from 'web-library';
import RouteKey from '../../../routes/key';
import { candidateService } from '../../../api';
import ReceiptDetail from '../../../components/ReceiptDetails';
import { stringToLongDateAndShortTime } from '../../../utils/DateUtils';
import { useWOGAA } from '../../../hooks/wogaa';

const useStyles = makeStyles()((theme) =>
({
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(2),
  },
  paymentLinkMessage: {
    marginBottom: theme.spacing(4),
  },
}));

interface AmendmentReceiptPathParams {
  uuid?: string;
}

const { amendment } = RouteKey.child;
const {
  examRegistrations: amendExamRegistrations,
  viewDetails,
  coordinatorExamRegistrations,
  coordinatorViewDetails,
} = RouteKey.amendment.child;

const { summary: paymentSummary, amendmentRegistration } = RouteKey['payment-link'].child;
const { paymentLink } = RouteKey.child;

const AmendmentReceipt = ({
  isGroup = false,
  isPaymentLink = false,
}: {
  isGroup?: boolean;
  isPaymentLink?: boolean;
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { uuid } = useParams<AmendmentReceiptPathParams>();
  const { data } = candidateService.subject.candidate.useGetAmendmentTransactionInfo(uuid);

  const title: string = isGroup
    ? t('amendment->>GroupAmendmentReceipt.CandidateAmendmentDetails')
    : t('amendment->>AmendmentReceipt.Subject Amendment Details');
  let viewFullSummaryUrl: string = `/${amendment}/${amendExamRegistrations.route}/${uuid}/${viewDetails.route}`;
  if (isGroup) {
    viewFullSummaryUrl = `/${amendment}/${coordinatorExamRegistrations.route}/${coordinatorViewDetails.route}/${uuid}`;
  } else if (isPaymentLink) {
    viewFullSummaryUrl = `/${paymentLink}/${amendmentRegistration}/${uuid}/${paymentSummary}`;
  }

  const backToButtonLabel: string = isGroup
    ? t('amendment->>GroupAmendmentReceipt.ViewSubjectAmendmentApplications')
    : t('amendment->>AmendmentReceipt.View Registered Exam');
  const backToListingUrl: string = isGroup
    ? `/${amendment}/${coordinatorExamRegistrations.route}`
    : `/${amendment}/${amendExamRegistrations.route}`;

  const applicationDateTime = data?.applicationDateTime
    ? stringToLongDateAndShortTime(data.applicationDateTime)
    : '';

   const { transactionEnd } = useWOGAA(isGroup ? 'myexamsseab-6455' : 'myexamsseab-6452');
      /** WOGAA complete transaction for registration amendment flow and coordinator amendment flow
        * */
       transactionEnd(uuid);


  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <SectionHeader
            title={title}
          >
            <Link id="link-viewFullSummary" onClick={() => history.push(viewFullSummaryUrl)}>
              <Typography variant="h5">
                {t('amendment->>AmendmentReceipt.View full summary')}
              </Typography>
            </Link>
          </SectionHeader>
        </Grid>
      </Grid>

      {!data?.paymentLink ? (
        <ReceiptDetail
          transaction={{
            transactionNumber: data?.transactionNo || '',
            internalTransactionRef: data?.referenceNo,
            totalFee: data?.totalExamFee?.toString() || '',
            paymentMethod: data?.paymentMethod || '',
            paymentTimeStamp: data?.paymentDateTime || '',
            gstRegNo: data?.gstRegNo,
          }}
        />
      ) : (
        <Box>
          <Typography className={classes.paymentLinkMessage} variant="body1">
            {t('exam->>RegistrationSummary.PaymentLinkMessage')}
          </Typography>
          <KeyValue
            keyText={t('exam->>RegistrationSummary.ApplicationId')}
            capitalize={false}
            valueText={data?.applicationId}
          />
          <KeyValue
            keyText={t('exam->>RegistrationSummary.ApplicationDateTime')}
            capitalize={false}
            valueText={applicationDateTime}
          />
        </Box>
      )}

      <Button
        id="button-amendmentReceipt-goToRegisteredExams"
        className={classes.button}
        onClick={() => history.push(backToListingUrl)}
      >
        {backToButtonLabel}
      </Button>
    </>
  );
};
export default AmendmentReceipt;
